import * as Constants from 'const';
import { ListIndents, ParagraphType } from 'services/ArtboardConverter/constants';
import { Schemas } from 'services/ArtboardConverter/models';
import { convertIndentToPx } from 'services/ArtboardConverter/utils/getListIndent';
import { CustomListNode } from '../../nodes/CustomListNode';
import { ArtboardConverterStyles } from '../convertLexicalEditorState';
import { getParagraphFontSize } from './Paragraph';

export function createParagraphForList(
  node: CustomListNode,
  projectType: Constants.ProjectType,
  converterStyles: ArtboardConverterStyles,
  paragraphs: Schemas.ListItemParagraph[],
): Schemas.ListParagraph {
  const firstTextNode = node.getAllTextNodes()[0];
  const fontSizeNumber = getParagraphFontSize(firstTextNode, converterStyles.fontSize, projectType);

  const { convertListIndentToPx } = Constants.ProjectsConfig[projectType];
  let indents = ListIndents[projectType];
  if (convertListIndentToPx) {
    indents = convertIndentToPx(indents, fontSizeNumber);
  }
  const { margin, padding } = indents;

  return {
    type: ParagraphType.UNORDERED_LIST,
    margin,
    padding,
    paragraphs,
  };
}
